import styles from 'css/src/components/app/template-preview/TemplateSearchEmptyState.module.scss';

import React from 'react';

export interface TemplateSearchEmptyStateProps {
    searchQuery: string;
}

export const TemplateSearchEmptyState: React.FC<TemplateSearchEmptyStateProps> = ({
    searchQuery,
}) => {
    return (
        <div
            className={`${styles['template-search-empty-state']} d-flex align-items-center justify-content-center py-l5-64 px-l5-48 w-100`}
        >
            <div className={`${styles['empty-state-content']} text-center`}>
                <i
                    translate="no"
                    className={`material-symbols-outlined ${styles['empty-state-icon']} mb-l5-24`}
                >
                    search_off
                </i>
                <h4 className={`${styles['empty-state-title']} fw-semibold mb-l5-12`}>
                    No templates found
                </h4>
                <p className={`${styles['empty-state-description']} fs-7 mb-l5-0`}>
                    No templates match &quot;{searchQuery}&quot;. Try adjusting your search.
                </p>
            </div>
        </div>
    );
};
